export const sanitizeText = (text?: string | null, maxLength?: number): string => {
    if (!text) return '';
    const textStr = text == null ? '' : String(text);
    
    // First decode apostrophes only for readability
    const decoded = textStr.replace(/&#x27;/g, "'");
    
    // Then sanitize dangerous HTML characters (keep apostrophes readable)
    const sanitized = decoded.replace(/[&<>"]/g, (char) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;'
    })[char] || char);
    
    const limit = maxLength ?? 100;
    return sanitized.length > limit ? sanitized.substring(0, limit) : sanitized;
};
